export default __webpack_public_path__ + "static/media/Dive1.33a906ee.png";